import { render, staticRenderFns } from "./userRoleInfo.vue?vue&type=template&id=1aefb420&"
import script from "./userRoleInfo.vue?vue&type=script&lang=js&"
export * from "./userRoleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aefb420')) {
      api.createRecord('1aefb420', component.options)
    } else {
      api.reload('1aefb420', component.options)
    }
    module.hot.accept("./userRoleInfo.vue?vue&type=template&id=1aefb420&", function () {
      api.rerender('1aefb420', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameLog/userRoleInfo.vue"
export default component.exports